// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xxHGX4Pe2iYLm9ex {
  padding-bottom: 96px;
}

.i0ztZ_hTTq8vlMK0 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.xqRgHwca0AkHGGVy .p-orderlist-controls {
  display: none;
}

.YgVN8zF9AEta9fX_,
.XN8O1St6PPITRR7Y {
  display: flex;
}

.YgVN8zF9AEta9fX_ > div,
.XN8O1St6PPITRR7Y > div {
  width: 16%;
  align-self: center;
}

.b0oBX_NgYIbEL43c {
  margin-right: 5px;
}

.b0oBX_NgYIbEL43c,
.lfxV95L0oUyvzKus {
  margin-bottom: 5px;
  padding: 8px 14px;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid rgb(222, 226, 230);
  border-radius: 3px;
  display: inline-flex;
  align-items: center;
  background-color: #ffffff;
}

.yTOUNW2WlakZJyXp {
  margin-bottom: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Manager/components/StationMenuItem.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".pageWrapper {\r\n  padding-bottom: 96px;\r\n}\r\n\r\n.accordionHeader {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.listWrapper :global(.p-orderlist-controls) {\r\n  display: none;\r\n}\r\n\r\n.header,\r\n.stationMenuItem {\r\n  display: flex;\r\n}\r\n\r\n.header > div,\r\n.stationMenuItem > div {\r\n  width: 16%;\r\n  align-self: center;\r\n}\r\n\r\n.expandButton {\r\n  margin-right: 5px;\r\n}\r\n\r\n.expandButton,\r\n.collapseButton {\r\n  margin-bottom: 5px;\r\n  padding: 8px 14px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  border: 1px solid rgb(222, 226, 230);\r\n  border-radius: 3px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  background-color: #ffffff;\r\n}\r\n\r\n.isMultipleSelectButton {\r\n  margin-bottom: 15px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var pageWrapper = `xxHGX4Pe2iYLm9ex`;
export var accordionHeader = `i0ztZ_hTTq8vlMK0`;
export var listWrapper = `xqRgHwca0AkHGGVy`;
export var header = `YgVN8zF9AEta9fX_`;
export var stationMenuItem = `XN8O1St6PPITRR7Y`;
export var expandButton = `b0oBX_NgYIbEL43c`;
export var collapseButton = `lfxV95L0oUyvzKus`;
export var isMultipleSelectButton = `yTOUNW2WlakZJyXp`;
export default ___CSS_LOADER_EXPORT___;
